import { create } from 'zustand'
import type { QueueItemT } from '@/lib/types/bgSyncTypes.ts'
import { nativeQueueManager } from '@/lib/nativeSync/nativeQueueManager'

interface SyncQueueState {
  data: QueueItemT[]
  error: string | null
  readData: () => Promise<void>
}

export const useSyncQueueStore = create<SyncQueueState>(set => ({
  data: [],
  error: null,
  readData: async () => {
    try {
      const all = await nativeQueueManager.getAllEntries()
      set({ data: all, error: null })
    } catch (e) {
      const message = e instanceof Error ? e.message : 'Queue DB not ready'
      set({ error: message })
    }
  },
}))
